module.exports = __webpack_public_path__ + "img/media (17).6ba4ce02.png";